// Module-scoped endpoint paths for offerings (listing, filters, bookmark,
// invest-form). Property detail lives in the sibling property sub-module.

export const OFFERINGS_ENDPOINTS = {
  OFFERINGS: '/api/offerings',
  OFFERINGS_FILTERS: '/api/offerings/filters',
  BOOKMARK: '/api/offerings/{offeringId}/bookmark',
} as const
